import { render, staticRenderFns } from "./DevolucionesGeneralHandler.vue?vue&type=template&id=00b00efb&"
import script from "./DevolucionesGeneralHandler.vue?vue&type=script&lang=js&"
export * from "./DevolucionesGeneralHandler.vue?vue&type=script&lang=js&"
import style0 from "./DevolucionesGeneralHandler.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports